export enum UpgradeId {
    Factory = "Factory",
    FactorySquared = "FactorySquared",
    FactoryCubed = "FactoryCubed",
    FactoryTesseracted = "FactoryTesseracted",
    Synergy = 'Synergy',
    StrongerWeapons = "StrongerWeapons",
    CombatEfficiency = "CombatEfficiency",
    MassMurder = "MassMurder",
    MultiSpin = "MultiSpin",
    Grease = "Grease"
}